import React from "react";

const AboutPageGrid = ({ data, onCreate, onEdit, onDelete }) => {

  return (
    <section className="content container-fluid mt-4">
      <div className="row">
        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
          <div className="box box-primary">
            <div className="box-header with-border d-flex justify-content-between align-items-center">
              <h3>About Page Data</h3>
              <button className="btn btn-primary mb-3" onClick={onCreate}>
                Create Message
              </button>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Heading </th>
                    <th>Para </th>
                    <th>Image</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No data available.
                      </td>
                    </tr>
                  ) : (
                    data.map((msg, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{msg.heading}</td>
                        <td>{msg.para}</td>
                        <td>
                            {msg.imageurl && (
                              <img
                               src={ msg.imageurl}
                                alt="Preview"
                                style={{
                                  height: "100px",
                                  width: "100px",
                                  borderRadius: 6,
                                }}
                              />
                            )}
                          </td>
                        <td>
                          <button
                            className="btn btn-sm btn-warning me-2"
                            onClick={() => onEdit(msg.id)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => onDelete(msg.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPageGrid;
